// ClientReviewsSummary.jsx — "Feedback" block on a client's Profile tab: one line per trip
// review, with its rating, recommendation and public-use status. Click to open that trip's
// Review tab, where the full answers are.
import React, { useEffect, useState } from "react";
import { api } from "../api";
import { Stars, ReviewStatusPill, PublicUseBadge, dateRange, fmtDay } from "./reviewShared";

export default function ClientReviewsSummary({ client, onOpenTrip }) {
  const [reviews, setReviews] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get(`/crm/reviews/client/${client._id}`)
      .then((r) => alive && setReviews(Array.isArray(r) ? r : []))
      .catch(() => alive && setReviews([]));
    return () => { alive = false; };
  }, [client._id, client.trips?.length]);

  if (!reviews) return null;
  const trips = client.trips || [];

  return (
    <div>
      <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2.5">Feedback</p>
      {!reviews.length ? (
        <p className="text-xs text-slate-400">No feedback yet. A review email goes out when a trip is completed.</p>
      ) : (
        <div className="flex flex-col gap-2">
          {reviews.map((r) => {
            const idx = trips.findIndex((t) => t?.tripUid && t.tripUid === r.tripUid);
            return (
              <button
                key={r._id}
                type="button"
                disabled={idx === -1}
                onClick={() => onOpenTrip(idx)}
                className="w-full text-left p-3 rounded-xl border border-slate-100 hover:bg-slate-50 transition-colors flex flex-wrap items-center gap-x-3 gap-y-1.5 disabled:cursor-default"
              >
                <div className="flex-1 min-w-[160px]">
                  <p className="text-sm font-semibold text-slate-700">
                    {r.destination || "Trip"} <span className="font-normal text-slate-400">· {r.tripTypeLabel}</span>
                  </p>
                  <p className="text-xs text-slate-400">
                    {dateRange(r.startDate, r.endDate) || "No dates"}
                    {r.submittedAt ? ` · answered ${fmtDay(r.submittedAt)}` : ""}
                    {idx === -1 ? " · trip removed" : ""}
                  </p>
                </div>
                {r.overallRating ? <Stars value={r.overallRating} size={14} /> : null}
                {r.recommend && <span className="text-xs text-slate-500">Recommend: {r.recommend}</span>}
                <ReviewStatusPill review={r} />
                <PublicUseBadge review={r} />
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
